import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_that_work_laser_radiation_producing_equipment_do'

export const dataPointDefinition = {
  retracedId: 'workers_that_work_laser_radiation_producing_equipment_do',
  name: 'Workers that work with laser/radiation-producing equipment do not understand why and how to operate the equipment safely',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-wor-42x',
      number: 'HS-WOR-20-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-37',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-32--1,Yes',
      machineShowHide: '[2],hs-32--1,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-42x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31840,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
